"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactGtmModule = _interopRequireDefault(require("react-gtm-module"));
var _SecurityContextHolder = require("../api/SecurityContextHolder");
var _ApplicationContext = require("../api/ApplicationContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const initialize = () => {
  if (_ApplicationContext.ApplicationContext.getGoogleTagManagerId() && _ApplicationContext.ApplicationContext.getGoogleTagManagerId().length > 0 && !window.gtmLoaded) {
    const tagManagerArgs = {
      gtmId: _ApplicationContext.ApplicationContext.getGoogleTagManagerId()
    };
    _reactGtmModule.default.initialize(tagManagerArgs);
    window.gtmLoaded = true;
  }
};
const isAuthRelatedUrl = props => {
  const {
    logoutPath = _ApplicationContext.ApplicationContext.getLogoutPath(),
    loginPath = _ApplicationContext.ApplicationContext.getLoginPath(),
    launchPath = '/launch',
    launchErrorPath = '/launch/401',
    superUserloginPath = '/account_support/login.html',
    marketingReploginPath = '/sales/login.html',
    forgotPath = '/forgot.html',
    resetAccountPath = '/resetAccount.html',
    resetPasswordPath = '/resetPassword.html',
    profilePath = _ApplicationContext.ApplicationContext.getProfilePath(),
    azureRedirectPath = '/login/oauth2/code/'
  } = props;
  let isMatch = false;
  switch (window.location.pathname) {
    case loginPath:
      isMatch = true;
      break;
    case logoutPath:
      isMatch = true;
      break;
    case launchPath:
      isMatch = true;
      break;
    case launchErrorPath:
      isMatch = true;
      break;
    case superUserloginPath:
      isMatch = true;
      break;
    case marketingReploginPath:
      isMatch = true;
      break;
    case forgotPath:
      isMatch = true;
      break;
    case resetAccountPath:
      isMatch = true;
      break;
    case resetPasswordPath:
      isMatch = true;
      break;
    case profilePath:
      isMatch = true;
      break;
    case azureRedirectPath:
      isMatch = true;
      break;
    default:
      break;
  }
  return isMatch;
};
const WebAnalytics = props => {
  const routeAreas = _ApplicationContext.ApplicationContext.getGoogleTagManagerRouteAreas();
  const gtmId = _ApplicationContext.ApplicationContext.getGoogleTagManagerId();
  if (gtmId && gtmId.length > 0 && !window.gtmLoaded) {
    if (routeAreas && (routeAreas.indexOf('auth') >= 0 || routeAreas.indexOf('secure') >= 0 || routeAreas.indexOf('private') >= 0)) {
      if (_SecurityContextHolder.SecurityContextHolder.isAuthenticated() || isAuthRelatedUrl(props)) {
        initialize();
      }
    }
    if (routeAreas && routeAreas.indexOf('public') >= 0) {
      if (!_SecurityContextHolder.SecurityContextHolder.isAuthenticated() && !isAuthRelatedUrl(props)) {
        initialize();
      }
    }
  }
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
};
WebAnalytics.propTypes = {
  logoutPath: _propTypes.default.string,
  loginPath: _propTypes.default.string,
  launchPath: _propTypes.default.string,
  launchErrorPath: _propTypes.default.string,
  superUserloginPath: _propTypes.default.string,
  marketingReploginPath: _propTypes.default.string,
  forgotPath: _propTypes.default.string,
  resetAccountPath: _propTypes.default.string,
  resetPasswordPath: _propTypes.default.string,
  profilePath: _propTypes.default.string,
  azureRedirectPath: _propTypes.default.string
};
var _default = exports.default = WebAnalytics;
//# sourceMappingURL=WebAnalytics.js.map